import * as THREE from "three";
import { easeInOutCubic } from "../core/math";

export class FovTween {
  private camera: THREE.PerspectiveCamera;
  private startFov = 75;
  private targetFov = 75;
  private duration = 0;
  private elapsed = 0;
  private active = false;

  constructor(camera: THREE.PerspectiveCamera) {
    this.camera = camera;
    this.startFov = camera.fov;
    this.targetFov = camera.fov;
  }

  tweenTo(targetFov: number, durationSeconds: number): void {
    this.startFov = this.camera.fov;
    this.targetFov = targetFov;
    this.duration = Math.max(0.0001, durationSeconds);
    this.elapsed = 0;
    this.active = true;
  }

  setImmediate(fov: number): void {
    this.camera.fov = fov;
    this.startFov = fov;
    this.targetFov = fov;
    this.active = false;
    this.camera.updateProjectionMatrix();
  }

  update(dt: number): void {
    if (!this.active) return;
    this.elapsed += dt;
    const t = Math.min(1, this.elapsed / this.duration);
    const k = easeInOutCubic(t);
    this.camera.fov = this.startFov + (this.targetFov - this.startFov) * k;
    this.camera.updateProjectionMatrix();
    if (t >= 1) this.active = false;
  }
}
